<template>
    <div class="mt-number-wrap">
        <MtTitle title="产品案例" english="INTRODUCE" type="blue"></MtTitle>
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img1.png" alt="">
            <div class="text-content-title">线下网球馆：勾勾运动</div>
            <div class="text-content-subtitle">OFFLINE TENNIS STADIUM: HOOK SPORT</div>
            <div class="text-content">基于用户使用便捷性和场馆管理智能化考虑，为上海卢湾网球中心赋能，定制开发了一套集场地预定管理、会员申请审核、课程预定、优惠礼券、多种订单及财务退款等一体化在线智能管理系统，并提供双语版智能切换和多种用户角色切换功能，轻松实现管理智能化和高效性，打造成集运动、消费、社交等功能于一体的专注于网球运动垂直领域O2O的运动生活平台。</div>
        </div>
        <img data-src="../../static/img/content-img1.png" alt="">
        <div class="content-box">
            <div class="text-content-box">
                <img class="number-bg" data-src="../../static/img/bg-img2.png" alt="">
                <div class="text-content-title">线下画廊:艺直购</div>
                <div class="text-content-subtitle">OFFLINE GALLERY: ART DIRECT OURCHASE</div>
                <div class="text-content">将线下画廊从传统生意转变为STOBTOC的业务模式（消费艺术品垂直类的淘宝），实现艺术家和机构的入驻审核和作品发布，为艺术家、画廊机构和用户搭建起艺术作品交易新平台，开启线上销售渠道。并借助技术实力驱动产品创新，实现装裱效果和场装饰场景实时预览，给用户提供更直观的购买体验。</div>
            </div>
            <img data-src="../../static/img/content-img2.png" alt="">
        </div>
        
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img3.png" alt="">
            <div class="text-content-title">线下体育赛事：WCT追逐大赛</div>
            <div class="text-content-subtitle">OFFLINE SPORTS EVENTS: WORLD CHASE COMPETITION</div>
            <div class="text-content">WCT追逐大赛小程序端结合后台管理系统，为官方发布赛事信息、统计用户报名信息、比赛成绩和更新排名实现数字化和信息化，为用户提供从赛前、赛中到赛后提供一站式服务。</div>
        </div>
        <img style="margin-bottom: 10vw" data-src="../../static/img/content-img3.png" alt="">
    </div>
</template>
<script>
import MtTitle from '../components/Mt-title'
export default {
    name: 'mt-linkLine',
    components: {
        MtTitle
    },
    data(){
        return {

        }
    },
    created(){
        localStorage.setItem('path','./mt_linkLine')
        localStorage.setItem('index',3)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
.content-box{
    width: 100%;
    background: #F6F7FC;
    padding-top: 1vw;
    padding-bottom: 5vw;
}
.content-box > img{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 5vw;
}
.mt-number-wrap > img{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 5vw;
    margin-bottom: 5vw;
}
.text-content-box{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 20vw;
    position: relative;
}
.number-bg{
    position: absolute;
    top: -8.5vw;
    left: 4.6vw;
    height: 32vw;
}
.text-content-title{
    font-size: 5.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 8.13vw;
}
.text-content-subtitle{
    font-size: 3.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 5.37vw;
}
.text-content{
    margin-top: 7vw;
    font-size: 3.38vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 6.35vw;
}
.text-content > span{
    font-size: 3.87vw;
    color: #4468E6;
}
</style>


// WEBPACK FOOTER //
// src/pages/mt_linkLine.vue